/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttendanceAuditLogBasesResponse } from '../../models/attendance-audit-log-bases-response';

export interface ListAttendanceAuditLogBases$Params {
}

export function listAttendanceAuditLogBases(http: HttpClient, rootUrl: string, params?: ListAttendanceAuditLogBases$Params, context?: HttpContext): Observable<StrictHttpResponse<AttendanceAuditLogBasesResponse>> {
  const rb = new RequestBuilder(rootUrl, listAttendanceAuditLogBases.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AttendanceAuditLogBasesResponse>;
    })
  );
}

listAttendanceAuditLogBases.PATH = '/api/scheduler/attendance-audit-logs/bases';
